const baseUri = "https://api.phonekadai.com/chit-fund";

export default baseUri;